import qs from 'query-string';
import { get, post, put, del } from './baseApi';

export const UserApi = {
    fetch: (query) => get(`/users?${qs.stringify(query)}`),
    fetchById: (id) => get(`/users/${id}`),
    create: (data) => post('/users', data),
    update: (id, data) => put(`/users/${id}`, data),
    delete: (id) => del(`/users/${id}`),
    fetchPermissions: () => get('/users/me/permissions'),
    updateMe: (data) => put(`/users/me`, data),
};
